// extracted by mini-css-extract-plugin
module.exports = {"verifiedOld":"verified-badge_verifiedOld__zcaba","verifiedBlue":"verified-badge_verifiedBlue__s3_Vu","verifiedGovernment":"verified-badge_verifiedGovernment__qRJxq"};